// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as ArrowRightDefault } from '../../../../../ui-v3/src/assets/icons/default/arrows/arrow-right.svg?react';
import { ReactComponent as ArrowRightSolid } from '../../../../../ui-v3/src/assets/icons/solid/arrows/ARROW-RIGHT.svg?react';
import { createIcons } from '../../Icon';
const ArrowRightIcon = /* @__PURE__ */ createIcons('ArrowRight', {
    default: ArrowRightDefault,
    solid: ArrowRightSolid
});
ArrowRightIcon.supportedTypes = [
    'default',
    'solid'
];
ArrowRightIcon.category = 'arrows';
export default ArrowRightIcon;
